// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"607cecdb","703":"f95e2015","787":"919cd90e"}[chunkId] + ".chunk.js";
};